import { UserDataRestoreService } from '@aca-new/app/shared/services/user-services/user-data-restore/user-data-restore.service';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RestoreUserDataGuard implements CanActivate {
  public constructor(private readonly _userDataRestoreService: UserDataRestoreService) {}

  public async canActivate(): Promise<boolean> {
    await this._userDataRestoreService.tryRestoreUserData();

    return true;
  }
}
